import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import workspaceReducer from "./slices/workspaceSlice";
import onboardingReducer from "./slices/onboardingSlice";
import debugReducer from "./slices/debugSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    workspace: workspaceReducer,
    onboarding: onboardingReducer,
    debug: debugReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
